import { AxiosRequestConfig } from 'axios'
import { getFilter, getPagination, getSort } from '../../network/network'
import { GatewayType, ReqConfigModel } from './api.types'
import { RequestHeaders } from '../../network/network.types'
import { provideEnvConfigOld } from '../helpers/env'
import { provideBaseUrls } from '../../helpers/urlProvider'

/**
 * Gets API base URL
 *
 * @param gateway Enviroment gateway
 * @param region Country region
 * @returns Base URL
 */
export const mapGatewayType = (gateway: GatewayType) => {
    switch (gateway) {
        case 'api':
            return 'lk_api'
        case 'sockets':
            return 'lk_sockets'
        default:
            return gateway
    }
}

export const getApiBaseUrlLkProxy = (
    gateway: GatewayType,
    region: string
): string => {
    const api_env = provideEnvConfigOld().api_env
    const baseURL = provideBaseUrls(api_env)[mapGatewayType(gateway)]

    return baseURL.replace('{region}', region)
}
/**
 * Gets Bearer token
 *
 * @param jwt JSON Web Token
 * @returns Bearer token
 */
export const getToken = (jwt: string) => {
    if (!jwt) return ''
    return `Bearer ${jwt}`
}

/**
 * Adds Bearer token to request headers and returns them
 *
 * @param jwt JSON Web Token
 * @param custom Custom headers for request
 * @returns Request headers
 */
export const getHeaders = (jwt?: string, custom?: RequestHeaders) => {
    const common: Record<string, string> = {}
    const headers = { common, ...custom }
    const token = getToken(jwt ?? '')
    if (token) headers.common.Authorization = token
    // SAFETY: axios flattens the per-request `common` group at runtime; its typings only model `common` as an AxiosHeaders instance
    return headers as AxiosRequestConfig['headers']
}

/**
 * Extracts parameters from config and adds them to URL
 *
 * @param url
 * @param config request configuration parameters
 * @returns URL with added parameters
 */
export const buildURL = (
    url: string,
    config?: ReqConfigModel['params']
): string => {
    const stringConfig = Object.entries(config ?? {})
        .filter(([, value]) => value)
        .map(([key, value]) => {
            return Array.isArray(value)
                ? value.map(v => `${key}=${v}`).join('&')
                : `${key}=${value}`
        })
        .join('&')
    const configParams = stringConfig ? `?${stringConfig}` : ''
    return `${url}${configParams}`
}

/**
 * @param error
 * @returns Error response status
 */
export const errorStatus = (error: any) => error?.response?.status

export const errorBody = (
    error: any
): { msg: string; type: string; reson: any } => error?.response?.data?.error

/**
 * Extracts pagination, filter and sort objects from request config
 * and adds their properties to params.
 *
 * @param config
 * @returns Config object with params prepared for request
 */
export const getLKRequestConfig = (config: ReqConfigModel) => {
    const { filter, params, sort, pagination } = config || {}
    const paginationQuery = getPagination(pagination)
    const filterQuery = getFilter(filter)
    const sortQuery = getSort(sort)
    return {
        ...config,
        params: { ...params, ...filterQuery, ...sortQuery, ...paginationQuery }
    }
}
